const env = "production"; // | dev | testing | staging

const urls = {
  local: "http://localhost",
  staging: "https://ofpro.loqusgroup.com",
  production: "https://management.openfleetpro.com",
};

const config = {
  apiAddress: {
    main: {
      url: urls[env],
      virtualPath: "/proapi/",
    },
    pro_client: {
      url: urls[env],
      virtualPath: "/procliapi/"
    },
    intapi: {
      url: urls[env],
      virtualPath: "/intapi/"
    },
    login: {
      url: urls[env],
      virtualPath: "/loginapi/"
    },
    disapi: {
      url: urls[env],
      virtualPath: "/disapi/"
    },
    clientin: {
      url: urls[env],
      virtualPath: "/api/in/"
    },
    mdapi: {
      url: urls[env],
      virtualPath: "/mdapi/api/v1/"
    },
  },
  websocketConfig: {
    clients: {
      url: "https://management.openfleetpro.com",
      virtualPath: "cliskt",
      // suffixPath: null // eg. /route
    },
    settings: {
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0.5,
    },
  },
};

export default config;
